import React from 'react'
import { Link } from 'react-router-dom'

const PageBreadcrumbs = (props) => {
  const profileLinkUser = props.profileDetailLink;
  return (
    <>
     <div className="row justify-content-center">
                <div className={props.colFull ? 'col-lg-12' : 'col-lg-10'}>
                    <nav aria-label="breadcrumb d-inline">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard" title='Dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">{props.pagename}</li>
                        </ol>
                    </nav>
                    {props.disableDashLink ? null : 
                    <Link to="/dashboard" state={{detail:profileLinkUser}} title='Dashboard' className="goto_dash mb-2 add-profile box py-2 px-3 float-sm-end d-inline-block">
                    <i className="las la-angle-left"></i> Go to Dashboard</Link>
                    }
                    
                </div>
            </div>
    </>
  )
}

export default PageBreadcrumbs
